module.exports = __webpack_public_path__ + "img/MoneyInformation.49e52ddc.svg";